import styled from 'styled-components';

export const Container = styled.button`
  grid-area: export;
  justify-self: end;
  background: #000fff;
  box-shadow: 0px 2px 4px #00000034;
  border-radius: 6px;
  opacity: 1;
  width: 184px;
  height: 37px;
  border: none;
  color: #ffff;
  outline: none !important;
  opacity: 1;
  transition: opacity 0.1s;
  font-size: 0.9rem;

  @media (max-width: 768px) {
    width: 100%;
    justify-self: start;
  }

  &:hover {
    opacity: 0.6;
  }

  svg {
    margin-right: 8px;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;
